import { Divider, Grid, List, ListItem, ListItemText, Skeleton, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { usePermissionStore } from "../../../hooks/usePermissionStore";
import { ApiStatus } from "../../../types/api/status";
import { PermissionUser } from "../../../types/slices/permissionType";
import { readLocalStorage } from "../../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../../types";
import { Role } from "../../../types/roles/roleTypes";

const skeletonRange = [1,2,3,4,5,6,7,8,9,10]
const dataCrud = [
    {id:1, description:'Leer'},
    {id:2, description:'Crear'},
    {id:3, description:'Actualizar'},
    {id:4, description:'Eliminar'}
]

type DataTable = {
    id:number
    description:string
    status:number
}

export const TabPermissions: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, userSelected, listUser, clearState } = props;

    const { status: statusPermission, permissions, permissionsByUserType, getPermissionByUserType, getPermissions, getPermissionUser, createPermissionUser, editPermissionUser } = usePermissionStore()

    const [dataTable, setDataTable] = useState<DataTable[]>([])
    const [dataTable2, setDataTable2] = useState<DataTable[]>([])
    const [permissionsUser, setPermissionsUser] = useState<PermissionUser|null>(null)

    useEffect(()=>{
        getPermissionsData()
    },[])
    
    useEffect(() => {
        setDataTableAll()
    },[permissions, permissionsByUserType, permissionsUser])

    const getPermissionsData = async () => {
        const response = await getPermissionUser({ iduser: userSelected.id })
        if (response.length === 1) setPermissionsUser(response[0])
        await getPermissionByUserType({ iduser_type: userSelected.iduser_type })
        await getPermissions()
    }

    const setDataTableAll = () => {
        if (permissions.length === 0 || permissionsByUserType.length === 0) return

        let data:DataTable[] = []
        let data2:DataTable[] = []

        if (!permissionsUser) {
            data = permissions.map(permission => ({
                id: permission.id,
                description: permission.description,
                status: permissionsByUserType[0].permissions.includes(permission.id) ? 1: 0
            }))

            if (userSelected.userType !== Role.SUPER_ADMIN && userSelected.userType !== Role.ADMIN) {
                data2 = dataCrud.map(row => ({
                    id: row.id,
                    description: row.description, 
                    status: 1
                }))
            }
        } else {
            data = permissions.map(permission => ({
                id: permission.id,
                description: permission.description,
                status: permissionsUser.permissions.includes(permission.id) ? 1: 0
            }))

            if (userSelected.userType !== Role.SUPER_ADMIN && userSelected.userType !== Role.ADMIN) {
                data2 = dataCrud.map(row => ({
                    id: row.id,
                    description: row.description, 
                    status: permissionsUser.actions.includes(row.id) ? 1 : 0
                }))
            }
        }

        setDataTable(data || [])
        setDataTable2(data2 || [])
    }

    const changeStatus = async (rowSelected, type) => {
        let permissions:number[] = []
        let actions:number[] = []

        if (type === 1) {
            if (rowSelected.status === 1) {
                permissions = dataTable.filter(row => row.status === 1).filter(row => row.id !== rowSelected.id).map(row => row.id)
                actions = dataTable2.filter(row => row.status === 1).map(row => row.id)
            } else {
                permissions = [...dataTable.filter(row => row.status === 1).map(row => row.id), rowSelected.id]
                actions = dataTable2.filter(row => row.status === 1).map(row => row.id)
            }
        } else {
            if (rowSelected.status === 1) {
                permissions = dataTable.filter(row => row.status === 1).map(row => row.id)
                actions = dataTable2.filter(row => row.status === 1).filter(row => row.id !== rowSelected.id).map(row => row.id)
            } else {
                permissions = dataTable.filter(row => row.status === 1).map(row => row.id)
                actions = [...dataTable2.filter(row => row.status === 1).map(row => row.id), rowSelected.id]
            }
        }

        let payload:any = {
            permissions: permissions,
            actions: actions
        }
        if (!permissionsUser) {
            payload = {
                ...payload,
                iduser: userSelected.id
            }
        }
        const response = await (!permissionsUser ? createPermissionUser(payload) : editPermissionUser(permissionsUser.id, payload))
        if (response === true) getPermissionsData()
    }

    return (
        <Grid >
            <Grid container>
                <Grid item container xs={12} spacing={2} display='flex' justifyContent='space-between'>
                    {
                        statusPermission !== ApiStatus.FETCHED
                        ?
                        <>
                        {skeletonRange.map(row => (
                            <Grid item container xs={12} md={6} spacing={2}>
                                <Grid item xs={8}>
                                    <Skeleton sx={{ height: 30 }} animation="wave" variant="rectangular"/>
                                </Grid>
                                <Grid item xs={4}>
                                    <Skeleton sx={{ height: 30 }} animation="wave" variant="rectangular"/>
                                </Grid>
                            </Grid>
                        ))}
                        </>
                        :
                        <>
                        {dataTable.map(row => (
                            <Grid item xs={12} md={6}>
                                <List
                                    sx={{ width: '100%', bgcolor: 'background.paper' }}
                                >
                                    <ListItem>
                                        <ListItemText id = "switch-list-label-wifi" primary = {row.description} />
                                        <Switch
                                            edge="end"
                                            onChange={() => changeStatus(row, 1)}
                                            checked={row.status === 1 ? true : false}
                                            inputProps={{
                                                'aria-labelledby': 'switch-list-label-wifi',
                                            }}
                                        />
                                    </ListItem>
                                </List>
                            </Grid>
                        ))}
                        <Divider sx={{ borderStyle: 'dashed' }} />
                        {dataTable2.map(row => 
                            <Grid item xs={12} md={6}>
                                <List
                                    sx={{ width: '100%', bgcolor: 'background.paper' }}
                                >
                                    <ListItem>
                                        <ListItemText id = "switch-list-label-wifi" primary = {row.description} />
                                        <Switch
                                            edge="end"
                                            onChange={() => changeStatus(row, 2)}
                                            checked={row.status === 1 ? true : false}
                                            inputProps={{
                                                'aria-labelledby': 'switch-list-label-wifi',
                                            }}
                                        />
                                    </ListItem>
                                </List>
                            </Grid>
                        )}
                        </>
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}